const doc = [({"en":({"js":({"admin":({"invoice_lines":({"table":({"vat":"Vat"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;